import React, { useEffect, useRef } from "react";
import { injectIntl } from "react-intl";
import IntlMessages from "../../helpers/IntlMessages";
import { Badge } from "reactstrap";

const KeyboardShortcutsModal = ({ isOpen, toggle, intl }) => {
  const shortcuts = [
    {
      key: "F1",
      description: intl.formatMessage({ id: "home.shortcut.f1" }),
      icon: "simple-icon-question",
    },
    {
      key: "F2",
      description: intl.formatMessage({ id: "home.shortcut.f2" }),
      icon: "simple-icon-magnifier",
    },
    {
      key: "F3",
      description: intl.formatMessage({ id: "home.shortcut.f3" }),
      icon: "simple-icon-grid",
    },
    {
      key: "F4",
      description: intl.formatMessage({ id: "home.shortcut.f4" }),
      icon: "simple-icon-tag",
    },
    {
      key: "F8",
      description: intl.formatMessage({ id: "home.shortcut.f8" }),
      icon: "simple-icon-printer",
    },
    {
      key: "F9",
      description: intl.formatMessage({ id: "home.shortcut.f9" }),
      icon: "simple-icon-credit-card",
    },
    {
      key: "F10",
      description: intl.formatMessage({ id: "home.shortcut.f10" }),
      icon: "simple-icon-docs",
    },
  ];
  const popupRef = useRef(null);

  // Handle ESC key and click outside to close
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        toggle();
      }
    };

    const handleClickOutside = (e) => {
      // Check if click is outside popup and not on the keyboard icon button
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        const keyboardBtn = document.querySelector(".floating-keyboard-btn");
        if (!keyboardBtn || !keyboardBtn.contains(e.target)) {
          toggle();
        }
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
      // Delay adding click listener to prevent immediate close
      setTimeout(() => {
        document.addEventListener("mousedown", handleClickOutside);
      }, 100);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggle]);

  if (!isOpen) return null;

  return (
    <div
      ref={popupRef}
      style={{
        position: "fixed",
        bottom: "70px",
        right: "10px",
        width: "300px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        zIndex: 1050,
        padding: "16px",
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0 font-weight-bold">
          <i className="iconsminds-keyboard mr-2" />
          <IntlMessages id="home.shortcut.title" />
        </h6>
        <button
          type="button"
          className="close"
          onClick={toggle}
          aria-label="Close"
          style={{ fontSize: "1.2rem" }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div className="shortcuts-list">
        {shortcuts.map((shortcut, index) => (
          <div
            key={index}
            className="d-flex align-items-center justify-content-between py-2"
            style={{
              borderBottom:
                index < shortcuts.length - 1 ? "1px solid #f3f3f3" : "none",
            }}
          >
            <div className="d-flex align-items-center">
              <i
                className={`${shortcut.icon} text-muted mr-2`}
                style={{ width: "18px", fontSize: "0.85rem" }}
              />
              <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                {shortcut.description}
              </span>
            </div>
            <Badge
              color="light"
              className="text-dark font-weight-bold"
              style={{
                padding: "4px 10px",
                fontSize: "0.75rem",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                minWidth: "36px",
                textAlign: "center",
              }}
            >
              {shortcut.key}
            </Badge>
          </div>
        ))}
      </div>

      <div
        className="text-center mt-2 pt-2"
        style={{ borderTop: "1px solid #eee" }}
      >
        <small className="text-muted" style={{ fontSize: "0.75rem" }}>
          <IntlMessages id="home.shortcut.close" />
        </small>
      </div>
    </div>
  );
};

export default injectIntl(KeyboardShortcutsModal);
